interface TopicItem {
  label: string;
  heat: number;
  desc: string;
  icon: string;
}

const topics: TopicItem[] = [
  { label: '古装权谋', heat: 98, desc: '宫廷剧迷必追片单', icon: 'ri-sword-line' },
  { label: '悬疑烧脑', heat: 95, desc: '反转不断的推理神作', icon: 'ri-search-eye-line' },
  { label: '甜宠爱情', heat: 92, desc: '糖分超标的浪漫好剧', icon: 'ri-heart-line' },
  { label: '科幻未来', heat: 87, desc: '脑洞大开的硬核科幻', icon: 'ri-rocket-line' },
  { label: '都市职场', heat: 84, desc: '职场人生百态全记录', icon: 'ri-building-line' },
  { label: '热血动漫', heat: 91, desc: '燃到炸裂的动画佳作', icon: 'ri-flashlight-line' },
  { label: '韩剧精选', heat: 89, desc: '高分韩剧一网打尽', icon: 'ri-kakao-talk-line' },
  { label: '美剧专区', heat: 86, desc: '原声中字同步更新', icon: 'ri-global-line' },
  { label: '高分综艺', heat: 80, desc: '下饭神器欢乐不断', icon: 'ri-emotion-laugh-line' },
];

export default function SectionTopics() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">大家都在追什么？话题热度实时更新</p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {topics.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="flex items-center gap-3 mb-3">
                <span className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                  <i className={`${item.icon} text-primary-600 text-base`}></i>
                </span>
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading text-sm text-foreground-900 truncate">{item.label}</h3>
                </div>
              </div>
              <div className="flex items-center gap-2 mb-2">
                <div className="flex-1 h-1.5 bg-background-200 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-primary-500 rounded-full transition-all duration-500"
                    style={{ width: `${item.heat}%` }}
                  ></div>
                </div>
                <span className="text-xs font-bold text-primary-600 whitespace-nowrap">{item.heat}°</span>
              </div>
              <p className="text-xs text-foreground-400">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}